export enum ScopeTag {
	WATER_MITIGATION = "water_mitigation",
	EXTERIOR_RECONSTRUCTION = "exterior_reconstruction",
	INTERIOR_RECONSTRUCTION = "interior_reconstruction",
	CONTENTS = "contents",
	MOLD = "mold",
	FIRE_MITIGATION = "fire_mitigation",
	DRAFT = "draft",
	BIOHAZARD = "biohazard",
	TIME_AND_MATERIAL = "time_and_material",
}

export function getScopeTagDisplayName(scope: ScopeTag | string): string {
	const displayNames: Record<ScopeTag | string, string> = {
		[ScopeTag.WATER_MITIGATION]: "Water Mitigation",
		[ScopeTag.EXTERIOR_RECONSTRUCTION]: "Exterior Reconstruction",
		[ScopeTag.INTERIOR_RECONSTRUCTION]: "Interior Reconstruction",
		[ScopeTag.CONTENTS]: "Contents",
		[ScopeTag.MOLD]: "Mold",
		[ScopeTag.FIRE_MITIGATION]: "Fire Mitigation",
		[ScopeTag.DRAFT]: "Draft",
		[ScopeTag.BIOHAZARD]: "Biohazard",
		[ScopeTag.TIME_AND_MATERIAL]: "Time and Material",
	};
	return displayNames[scope] || scope;
}
